import { Component } from "@angular/core";
import { SharedModule } from '../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
    selector: 'app-under-construction',
    templateUrl: 'under-construction.component.html',
    styleUrls: ['./under-construction.component.scss']
})

export class UnderConstructionComponent {
    
}
